import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useRecoilValue, useRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { AnimatePresence } from 'framer-motion';
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-duotone-svg-icons';
import { useHistory } from 'react-router-dom';
import Button from '../../shared-components/buttons/Button';
import Form from '../../shared-components/form/Form';
import Input from '../../shared-components/form/Input';
import PhoneInput from '../../shared-components/form/PhoneInput';
import Select from '../../shared-components/form/Select';
import Checkbox from '../../shared-components/form/Checkbox';
import { userAtom, userPrivilagesAtom, notificationsAtom } from '../../../atoms/Atoms';
import MainPage from '../../shared-components/main-page/MainPage';
import { H1, H2, H4 } from '../../shared-components/typography/Title';
import rayo from '../../../assets/images/characters/rayo.png';
import {
  prMunicipalities,
  ageGroups,
  salaryGroups,
  averageMonthlyPaymentGroups,
  creditScoreGroups,
  roofTypes
} from '../../../utils';
import api from '../../../api/api';
import './shared-components/home.css';

function Home() {
  const user = useRecoilValue(userAtom);
  const history = useHistory();
  const { t } = useTranslation();
  const userPrivilages = useRecoilValue(userPrivilagesAtom);
  const [notifications, setNotifications] = useRecoilState(notificationsAtom);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    // formik.setValues(formDefaultValues);
    // setTimeout(() => {
    //   setShowForm(true);
    // }, 750);
  }, []);

  return (
    <MainPage>
      <div className="space-y-8">
        <div className="grid gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-12">
          <div className="col-span-1 lg:col-span-7">
            <H1 className="text-center" text={t('main_page_title')} />
            <div className="flex flex-row items-center gap-4">  
              <img src={rayo} alt="Rayo" className="w-1/4 h-auto" />
              <p className="text=xl">
                {t('intro_text')}
              </p>
            </div>
          </div>
          <Button
            className="w-full md:w-1/2 lg:w-1/3 mx-auto md:my-auto bg-green-600 col-span-1 lg:col-span-5 hidden"
            textColor="text-primaryTextColor"
            borderColor="border-primaryBorderColor"
            text={t('prequalification_form')}
            iconRight
            onClick={() => history.push('/lg/solarx')}
          />
        </div>
        <div className="bg-white px-12 py-24 gap-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          <div className="card-content  flex flex-col">
            <H2 className="text-center" text={t('lesson_header')} />
            <p className="my-4 h-48">
              {t('lesson_description')}
            </p>
            <Button
              className="w-full ml-auto bg-primaryColor mb-6 px-6 mt-auto"
              textColor="text-primaryTextColor"
              loaderColor="bg-primaryTextColor"
              borderColor="border-primaryBorderColor"
              loading={loading}
              text={t('explore')}
              icon={faArrowRight}
              iconRight
            />
          </div>
          <div className="card-content  flex flex-col">
            <H2 className="text-center" text={t('test_your_knowledge_header')} />
            <p className="my-4 h-48">
              {t('test_your_knowledge_description')}
            </p>
            <Button
              className="w-full ml-auto bg-primaryColor mb-6 px-6 mt-auto"
              textColor="text-primaryTextColor"
              loaderColor="bg-primaryTextColor"
              borderColor="border-primaryBorderColor"
              loading={loading}
              text={t('take_quiz')}
              icon={faArrowRight}
              iconRight
            />
          </div>
          <div className="card-content flex flex-col">
            <H2 className="text-center" text={t('ready_for_solar_header')} />
            <p className="my-4">
              {t('ready_for_solar_description')}
            </p>
            <Button
              className="w-full ml-auto bg-yellow-300 mb-6 px-6 mt-auto"
              textColor="black"
              loaderColor="white"
              borderColor="black"
              loading={loading}
              text={t('request_consultation')}
              icon={faArrowRight}
              iconRight
              onClick={() => history.push('/lg/gopanza')}
            />
          </div>
          <div className="card-content  flex flex-col">
            <H2 className="text-center" text={t('job_search_header')} />
            <p className="my-4 h-48">
              {t('job_search_description')}
            </p>
            <Button
              className="w-full ml-auto bg-primaryColor mb-6 px-6 mt-auto"
              textColor="text-primaryTextColor"
              loaderColor="bg-primaryTextColor"
              borderColor="border-primaryBorderColor"
              loading={loading}
              text={t('request')}
              icon={faArrowRight}
              iconRight
            />
          </div>
        </div>
      </div>
    </MainPage>
  );
}

export default Home;
